import {
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Checkbox,
  TextField,
  Select,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  FormControl,
  MenuItem,
  IconButton,
  useMediaQuery,
  CircularProgress,
  InputAdornment,
} from "@mui/material";
import { FiberManualRecord, Filter } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import config from "../../config";
import { Box, Button, Grid, Typography } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import ClearIcon from "@mui/icons-material/Clear";
import { makeStyles } from "@mui/styles";
import * as Actions from "../../redux/actions";
import { Radio, RadioGroup, FormLabel } from "@mui/material";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";
import { AttachMoney } from "@mui/icons-material";
import { styled } from "@mui/system";

const FilterModal = ({
  open,
  brandName,
  user,
  jwtToken,
  listData,
  Categories,
  setOpen,
  setFilter,
  subBreedGenetics,
  setOpenSucessAlert,
  loadBreeds,
  breedsRaw,
  subBreedsRaw,
  loadSubBreeds,
  loadSubBreedsGenetics,
  loadListings,
  loadServices,
  loadSubServices,
  page,
  loadServiceListings,
}) => {
  const DUMMY_PAYMENT_METHODS = [
    "Credit Card",
    "Debit Card",
    "PayPal Goods & Services",
    "PayPal Friends & Family",
    "Venmo",
    "Zelle",
    "Apple Pay",
    "Google Pay",
    "Cash App",
    "Chime",
    "Personal Check",
    "Cashier's Check",
    "Wire Transfer",
    "Cash",
    "Money Order",
    "Western Union",
    "Walmart Pay",
    "MoneyGram",
    "Bitcoin",
    "Dogecoin",
    "Ehtermeum",
    "Other Crypto",
    "Other",
  ];

  const [openDialog, setOpenDialog] = useState(false);

  const [priceMinValue, setPriceMinValue] = useState("");
  const [priceMaxValue, setPriceMaxValue] = useState("");
  const [location, setLocation] = useState("");
  const [minAge, setMinAge] = useState("");
  const [maxAge, setMaxAge] = useState("");
  const [availabilityStatus, setAvailabilityStatus] = useState("");
  const [gender, setGender] = useState("");
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [category, setCategory] = useState("");
  const [breed, setBreed] = useState();
  const [subBreed, setSubBreed] = useState("");
  const [variety, setVariety] = useState("");
  const [varieties, setVarieties] = useState([]);
  const [varietyGenetics, setVarietyGenetics] = useState([]);
  const [genetics, setGenetics] = useState("");

  const availability = [
    { name: "Active", key: "active_listing" },
    { name: "On hold", key: "on_hold" },
    { name: "Featured", key: "featured" },
    { name: "Sold", key: "sold" },
  ];
  const [selectedBreed, setSelectedBreed] = useState("");
  const [selectedSubBreed, setSelectedSubBreed] = useState("");

  const states = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];

  useEffect(() => {
    setBreed(breedsRaw);
  }, [breedsRaw]);

  useEffect(() => {
    setOpenDialog(open);
  }, [open]);

  const handleMinValue = (event) => {
    setPriceMinValue(event.target.value);
  };
  const handleMaxValue = (event) => {
    setPriceMaxValue(event.target.value);
  };

  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClearPrice = () => {
    setPriceMaxValue("");
    setPriceMinValue("");
  };
  const handleClearLocation = () => {
    setLocation("");
  };
  const handleClearAge = () => {
    setMinAge("");
    setMaxAge("");
  };

  const handleClearAvailabilityStatus = () => {
    setAvailabilityStatus("");
  };
  const handleClearGender = () => {
    setGender("");
  };
  const handleClearPaymentMethod = () => {
    setPaymentMethods([]);
  };
  const handleClearCategory = () => {
    setCategory("");
    setSubBreed("");
    setSelectedBreed("");
    setVariety("");
    setVarieties([]);
    setVarietyGenetics([]);
  };
  const handleClearBreed = () => {
    setSelectedBreed("");
    setSubBreed("");
    setVariety("");
    setVarieties([]);
    setVarietyGenetics([]);
  };
  const handleClearSubBreed = () => {
    setSubBreed("");
    setVariety("");
    setVarieties([]);
    setVarietyGenetics([]);
    setGenetics("");
  };
  const handleClearVariety = () => {
    setVariety("");
    setVarietyGenetics([]);
    setGenetics("");
  };
  const handleClearGenetics = () => {
    setGenetics("");
  };
  const handleClearAll = () => {
    setPriceMaxValue("");
    setPriceMinValue("");
    setLocation("");
    setMinAge("");
    setMaxAge("");
    setAvailabilityStatus("");
    setGender("");
    setPaymentMethods([]);
    setCategory("");
    setSelectedBreed("");
    setSubBreed("");
    setVariety("");
    setVarieties([]);
    setVarietyGenetics([]);
    setGenetics("");
  };

  const handleApplyFilter = async () => {
    let updatedArray = [];

    if (priceMinValue) {
      updatedArray.push({ key: "min_price", label: "Min price: $" + priceMinValue, value: priceMinValue });
    }
    if (priceMaxValue) {
      updatedArray.push({ key: "max_price", label: "Max price: $" + priceMaxValue, value: priceMaxValue });
    }
    if (location) {
      updatedArray.push({ key: "location", label: "Location: " + location, value: location });
    }
    if (minAge) {
      updatedArray.push({ key: "min_age", label: "Min age: " + minAge, value: minAge });
    }
    if (maxAge) {
      updatedArray.push({ key: "max_age", label: "Max age: " + maxAge, value: maxAge });
    }
    if (availabilityStatus) {
      updatedArray.push({ key: "status", label: "Availability: " + availabilityStatus, value: availabilityStatus });
    }
    if (category) {
      updatedArray.push({ key: "category_id", label: "Category: " + category.name, value: category.id });
    }
    if (selectedBreed) {
      if (page !== "Services") {
        updatedArray.push({ key: "breed_id", label: "Breed: " + selectedBreed.name, value: selectedBreed.id });
      } else {
        updatedArray.push({ key: "sub_service_id", label: "Sub-Service: " + selectedBreed.name, value: selectedBreed.id });
      }
    }
    if (gender) {
      updatedArray.push({ key: "gender", label: "Gender: " + gender, value: gender });
    }
    if (subBreed) {
      updatedArray.push({ key: "sub_breed_id", label: "Sub-breed: " + subBreed.name, value: subBreed.id });
    }
    if (variety) {
      updatedArray.push({ key: "variety_id", label: "Variety: " + variety.name, value: variety.id });
    }
    if (genetics) {
      updatedArray.push({ key: "genetics", label: "Genetics: " + genetics.name, value: genetics.id });
    }
    if (paymentMethods.length > 0) {
      updatedArray.push({ key: "payment_methods", label: "Payment: " + paymentMethods.join(", "), value: paymentMethods });
    }

    setFilter(updatedArray);

    if (page === "Services") {
      const filtersData = {
        listing: {
          service_id: category && category.id,
          sub_service_id: selectedBreed && selectedBreed.id,
          min_price: priceMinValue && priceMinValue,
          max_price: priceMaxValue && priceMaxValue,
          location: location && location,
          payment_methods: paymentMethods && paymentMethods,
        },
      };

      try {
        loadServiceListings({
          filtersData,
          jwtToken,
        });
      } catch (error) {
        console.log("Error", error);
      }
    } else {
      const filtersData = {
        listing: {
          breed_id: selectedBreed && selectedBreed.id,
          category_id: category && category.id,
          sub_breed_id: subBreed && subBreed.id,
          variety_id: variety && variety.id,
          gender: gender && gender,
          min_price: priceMinValue && priceMinValue,
          max_price: priceMaxValue && priceMaxValue,
          min_age: minAge && minAge,
          max_age: maxAge && maxAge,
          genetics: genetics && genetics.id,
          location: location && location,
          payment_methods: paymentMethods && paymentMethods,
          status: availabilityStatus && availabilityStatus,
        },
      };

      try {
        loadListings({
          filtersData,
          jwtToken,
        });
      } catch (error) {
        console.log("Error", error);
      }
    }
    handleClose();
  };

  const handleMinAgeChange = (event) => {
    setMinAge(event.target.value);
  };

  const handleMaxAgeChange = (event) => {
    setMaxAge(event.target.value);
  };

  const handleLocationChange = (event) => {
    setLocation(event.target.value);
  };

  const handleAvailabilityStatus = (event) => {
    setAvailabilityStatus(event.target.value);
  };

  const handleSelectedCategoryChange = (event) => {
    if (event.target.value) {
      if (page !== "Services") {
        loadBreeds(event.target.value.id);
      } else {
        loadSubServices(event.target.value.id);
      }

      setCategory(event.target.value);
      setSelectedBreed("");
      setSubBreed("");
      setVariety("");
      setVarieties([]);
      setVarietyGenetics([]);
      setGenetics("");
    }
  };

  const handleSelectedBreedChange = (event) => {
    if (event.target.value) {
      if (page !== "Services") {
        loadSubBreeds(event.target.value.id);
      }
      setSelectedBreed(event.target.value);
      setGenetics("");
      setSelectedSubBreed("");
      setSubBreed("");
      setVariety("");
      setVarieties([]);
      setVarietyGenetics([]);
    }
  };
  useEffect(() => {
    if (subBreed != "") {
      loadSubBreedsGenetics(subBreed.id);
      fetchVarieties(subBreed.id);
    }
  }, [subBreed]);

  const fetchVarieties = async (subBreedId) => {
    try {
      const res = await axios.get(
        `${config.SERVER_URL}/api/v1/sub_breeds/${subBreedId}/varieties`,
        { headers: { "Content-Type": "application/json" } }
      );
      setVarieties(res.status === 200 ? res.data.data : []);
    } catch (err) {
      setVarieties([]);
    }
  };

  const handleSelectedVarietyChange = async (event) => {
    const selected = event.target.value;
    if (!selected) return;
    setVariety(selected);
    setGenetics("");
    try {
      const res = await axios.get(
        `${config.SERVER_URL}/api/v1/varieties/${selected.id}/genetics`,
        { headers: { "Content-Type": "application/json" } }
      );
      setVarietyGenetics(res.status === 200 ? res.data.data : []);
    } catch (err) {
      setVarietyGenetics([]);
    }
  };

  const handleSelectedSubBreedChange = (event) => {
    if (event.target.value) {
      setSubBreed(event.target.value);
      // loadSubBreedsGenetics(event.target.value);
    }
    setSelectedSubBreed(event.target.value);
    setVariety("");
    setVarietyGenetics([]);
    setGenetics("");
  };

  const handleSelectedGeneticsChange = (event) => {
    if (event.target.value) {
      setGenetics(event.target.value);
    }
  };
  const handlePaymentMethodChange = (event) => {
    const {
      target: { value },
    } = event;
    setPaymentMethods(typeof value === "string" ? value.split(",") : value);
  };

  const StyledRadio = styled(Radio)(({ theme }) => ({
    "& .MuiSvgIcon-root": {
      width: "16px",
      height: "16px",
    },
  }));

  const darkSelectSx = {
    backgroundColor: "#1a1a1a",
    color: "#fff",
    border: "1px solid #333",
    borderRadius: "10px",
    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
    "& .MuiSelect-icon": { color: "#666" },
    "&:hover": { borderColor: "#FFC001" },
  };

  const darkTextFieldSx = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#1a1a1a",
      color: "#fff",
      borderRadius: "10px",
      "& fieldset": { borderColor: "#333" },
      "&:hover fieldset": { borderColor: "#FFC001" },
      "&.Mui-focused fieldset": { borderColor: "#FFC001" },
    },
    "& .MuiInputLabel-root": { color: "#888" },
    "& .MuiInputAdornment-root": { color: "#888" },
  };

  const sectionLabelSx = {
    fontSize: { md: "15px", xs: "13px" },
    fontWeight: 700,
    color: "#FFC001 !important",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  };

  return (
    <>
      <Box position="relative">
        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="md"
          fullWidth
          sx={{
            "& .MuiDialog-paper": {
              width: { lg: "480px", md: "520px", xs: "95%" },
              maxHeight: { md: "85vh", xs: "90vh", sm: "85vh" },
              borderRadius: "16px",
              backgroundColor: "#0d0d0d",
              border: "1px solid #2a2a2a",
              color: "#fff",
              margin: { xs: "16px", md: "32px" },
              boxShadow: "0 24px 48px rgba(0,0,0,0.6)",
            },
          }}
        >
          {/* ── Header ── */}
          <Box sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 2,
            borderBottom: "1px solid #1e1e1e",
          }}>
            <Typography sx={{ fontSize: "20px", fontWeight: 800, color: "#fff !important" }}>
              Filters
            </Typography>
            <IconButton onClick={handleClose} sx={{ color: "#666", "&:hover": { color: "#FFC001", backgroundColor: "rgba(255,192,1,0.08)" } }}>
              <ClearIcon />
            </IconButton>
          </Box>

          {/* ── Content ── */}
          <DialogContent sx={{ px: 3, py: 2, backgroundColor: "#0d0d0d" }}>
            <Box sx={{ backgroundColor: "#111", borderRadius: "12px", p: 2, mb: 2, border: "1px solid #1e1e1e" }}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
                <Typography sx={sectionLabelSx}>Price Range</Typography>
                {(priceMinValue !== "" || priceMaxValue !== "") && (
                  <IconButton onClick={handleClearPrice} size="small" sx={{ color: "#666", "&:hover": { color: "#FFC001" } }}>
                    <ClearIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                )}
              </Box>
              <Box sx={{ display: "flex", gap: 1.5 }}>
                <TextField label="Min" fullWidth size="small" onChange={handleMinValue} value={priceMinValue} type="number" inputProps={{ min: 0 }} sx={darkTextFieldSx}
                  InputProps={{ endAdornment: <InputAdornment position="end" sx={{ color: "#888" }}><AttachMoney sx={{ fontSize: 18 }} /></InputAdornment> }}
                />
                <TextField label="Max" fullWidth size="small" value={priceMaxValue} onChange={handleMaxValue} type="number" inputProps={{ min: 0 }} sx={darkTextFieldSx}
                  InputProps={{ endAdornment: <InputAdornment position="end" sx={{ color: "#888" }}><AttachMoney sx={{ fontSize: 18 }} /></InputAdornment> }}
                />
              </Box>
            </Box>
            <Box sx={{ backgroundColor: "#111", borderRadius: "12px", p: 2, mb: 2, border: "1px solid #1e1e1e" }}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
                <Typography sx={sectionLabelSx}>Classes</Typography>
                {category && (
                  <IconButton onClick={handleClearCategory} size="small" sx={{ color: "#666", "&:hover": { color: "#FFC001" } }}>
                    <ClearIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                )}
              </Box>
              <FormControl sx={{ width: "100%" }}>
                <Select size="small" fullWidth name="category" value={category} MenuProps={MenuProps} onChange={handleSelectedCategoryChange} sx={darkSelectSx} displayEmpty
                  renderValue={(selected) => selected ? <Typography sx={{ color: "#fff !important" }}>{selected.name}</Typography> : <Typography sx={{ color: "#666 !important" }}>Select a class</Typography>}
                >
                  {Categories.map((list) => (
                    <MenuItem key={list.id} value={list} sx={{ color: "#fff", "&:hover": { backgroundColor: "#222", color: "#FFC001" } }}>
                      {list.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            {category && (
              <Box sx={{ backgroundColor: "#111", borderRadius: "12px", p: 2, mb: 2, border: "1px solid #1e1e1e" }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
                  <Typography sx={sectionLabelSx}>{page !== "Services" ? "Breed" : "Sub-Services"}</Typography>
                  {selectedBreed !== "" && (
                    <IconButton onClick={handleClearBreed} size="small" sx={{ color: "#666", "&:hover": { color: "#FFC001" } }}>
                      <ClearIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  )}
                </Box>
                <FormControl sx={{ width: "100%" }}>
                  <Select size="small" fullWidth name="breed" value={selectedBreed} MenuProps={MenuProps} onChange={handleSelectedBreedChange} sx={darkSelectSx} displayEmpty
                    renderValue={(selected) => selected ? <Typography sx={{ color: "#fff !important" }}>{selected.name}</Typography> : <Typography sx={{ color: "#666 !important" }}>Select a breed</Typography>}
                  >
                    {breedsRaw.map((list) => (
                      <MenuItem key={list.id} value={list} sx={{ color: "#fff", "&:hover": { backgroundColor: "#222", color: "#FFC001" } }}>{list.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            )}
            {page !== "Services" && subBreedsRaw?.length > 0 && selectedBreed && (
              <Box sx={{ backgroundColor: "#111", borderRadius: "12px", p: 2, mb: 2, border: "1px solid #1e1e1e" }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
                  <Typography sx={sectionLabelSx}>Sub-Breed</Typography>
                  {subBreed !== "" && (
                    <IconButton onClick={handleClearSubBreed} size="small" sx={{ color: "#666", "&:hover": { color: "#FFC001" } }}>
                      <ClearIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  )}
                </Box>
                <FormControl sx={{ width: "100%" }}>
                  <Select size="small" fullWidth name="subbreeds" value={subBreed} MenuProps={MenuProps} onChange={handleSelectedSubBreedChange} sx={darkSelectSx} displayEmpty
                    renderValue={(selected) => selected ? <Typography sx={{ color: "#fff !important" }}>{selected.name}</Typography> : <Typography sx={{ color: "#666 !important" }}>Select a sub-breed</Typography>}
                  >
                    {subBreedsRaw.map((list) => (
                      <MenuItem key={list.id} value={list} sx={{ color: "#fff", "&:hover": { backgroundColor: "#222", color: "#FFC001" } }}>{list.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            )}
            {page !== "Services" && varieties?.length > 0 && subBreed !== "" && (
              <Box sx={{ backgroundColor: "#111", borderRadius: "12px", p: 2, mb: 2, border: "1px solid #1e1e1e" }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
                  <Typography sx={sectionLabelSx}>Variety</Typography>
                  {variety !== "" && (
                    <IconButton onClick={handleClearVariety} size="small" sx={{ color: "#666", "&:hover": { color: "#FFC001" } }}>
                      <ClearIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  )}
                </Box>
                <FormControl sx={{ width: "100%" }}>
                  <Select size="small" fullWidth name="variety" value={variety} MenuProps={MenuProps} onChange={handleSelectedVarietyChange} sx={darkSelectSx} displayEmpty
                    renderValue={(selected) => selected ? <Typography sx={{ color: "#fff !important" }}>{selected.name}</Typography> : <Typography sx={{ color: "#666 !important" }}>Select a variety</Typography>}
                  >
                    {varieties.map((list) => (
                      <MenuItem key={list.id} value={list} sx={{ color: "#fff", "&:hover": { backgroundColor: "#222", color: "#FFC001" } }}>{list.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            )}
            {page !== "Services" && subBreed !== "" &&
              ((variety && varietyGenetics.length > 0) || (!variety && subBreedGenetics?.length > 0)) && (
              <Box sx={{ backgroundColor: "#111", borderRadius: "12px", p: 2, mb: 2, border: "1px solid #1e1e1e" }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
                  <Typography sx={sectionLabelSx}>Genetics</Typography>
                  {genetics !== "" && (
                    <IconButton onClick={handleClearGenetics} size="small" sx={{ color: "#666", "&:hover": { color: "#FFC001" } }}>
                      <ClearIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  )}
                </Box>
                <FormControl sx={{ width: "100%" }}>
                  <Select size="small" fullWidth name="genetics" value={genetics} MenuProps={MenuProps} onChange={handleSelectedGeneticsChange} sx={darkSelectSx} displayEmpty
                    renderValue={(selected) => selected ? <Typography sx={{ color: "#fff !important" }}>{selected.name}</Typography> : <Typography sx={{ color: "#666 !important" }}>Select genetics</Typography>}
                  >
                    {(variety ? varietyGenetics : subBreedGenetics).map((list) => (
                      <MenuItem key={list.id} value={list} sx={{ color: "#fff", "&:hover": { backgroundColor: "#222", color: "#FFC001" } }}>{list.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            )}

            {/* Location */}
            <Box sx={{ backgroundColor: "#111", borderRadius: "12px", p: 2, mb: 2, border: "1px solid #1e1e1e" }}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
                <Typography sx={sectionLabelSx}>Location</Typography>
                {location !== "" && (
                  <IconButton onClick={handleClearLocation} size="small" sx={{ color: "#666", "&:hover": { color: "#FFC001" } }}>
                    <ClearIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                )}
              </Box>
              <FormControl sx={{ width: "100%" }}>
                <Select size="small" fullWidth name="location" value={location} MenuProps={MenuProps} onChange={handleLocationChange} sx={darkSelectSx} displayEmpty
                  renderValue={(selected) => selected ? <Typography sx={{ color: "#fff !important" }}>{selected}</Typography> : <Typography sx={{ color: "#666 !important" }}>Select a state</Typography>}
                >
                  {states.map((list) => (
                    <MenuItem key={list} value={list} sx={{ color: "#fff", "&:hover": { backgroundColor: "#222", color: "#FFC001" } }}>{list}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            {/* Gender */}
            {page !== "Services" && (
              <Box sx={{ backgroundColor: "#111", borderRadius: "12px", p: 2, mb: 2, border: "1px solid #1e1e1e" }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
                  <Typography sx={sectionLabelSx}>Gender</Typography>
                  {gender !== "" && (
                    <IconButton onClick={handleClearGender} size="small" sx={{ color: "#666", "&:hover": { color: "#FFC001" } }}>
                      <ClearIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  )}
                </Box>
                <RadioGroup value={gender} onChange={handleGenderChange} row>
                  <FormControlLabel value="male" control={<StyledRadio sx={{ color: "#FFC001 !important" }} />}
                    label={<Box display="flex" alignItems="center" gap={0.5}><Typography sx={{ fontSize: "14px", color: "#ccc !important" }}>Male</Typography><MaleIcon sx={{ color: "#4FC3F7", fontSize: 18 }} /></Box>}
                  />
                  <FormControlLabel value="female" control={<StyledRadio sx={{ color: "#FFC001 !important" }} />}
                    label={<Box display="flex" alignItems="center" gap={0.5}><Typography sx={{ fontSize: "14px", color: "#ccc !important" }}>Female</Typography><FemaleIcon sx={{ color: "#F48FB1", fontSize: 18 }} /></Box>}
                  />
                  <FormControlLabel value="both" control={<StyledRadio sx={{ color: "#FFC001 !important" }} />}
                    label={<Box display="flex" alignItems="center" gap={0.5}><Typography sx={{ fontSize: "14px", color: "#ccc !important" }}>Pair</Typography><FemaleIcon sx={{ color: "#F48FB1", fontSize: 18 }} /><MaleIcon sx={{ color: "#4FC3F7", fontSize: 18 }} /></Box>}
                  />
                </RadioGroup>
              </Box>
            )}

            {/* Availability */}
            {page !== "Services" && (
              <Box sx={{ backgroundColor: "#111", borderRadius: "12px", p: 2, mb: 2, border: "1px solid #1e1e1e" }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
                  <Typography sx={sectionLabelSx}>Availability</Typography>
                  {availabilityStatus !== "" && (
                    <IconButton onClick={handleClearAvailabilityStatus} size="small" sx={{ color: "#666", "&:hover": { color: "#FFC001" } }}>
                      <ClearIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  )}
                </Box>
                <FormControl sx={{ width: "100%" }}>
                  <Select size="small" fullWidth name="availability" value={availabilityStatus} MenuProps={MenuProps} onChange={handleAvailabilityStatus} sx={darkSelectSx} displayEmpty
                    renderValue={(selected) => {
                      if (!selected) return <Typography sx={{ color: "#666 !important" }}>Select status</Typography>;
                      const found = availability.find(a => a.key === selected);
                      return <Typography sx={{ color: "#fff !important" }}>{found ? found.name : selected}</Typography>;
                    }}
                  >
                    {availability.map((list) => (
                      <MenuItem key={list.key} value={list.key} sx={{ color: "#fff", "&:hover": { backgroundColor: "#222", color: "#FFC001" } }}>{list.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            )}

            {/* Payment */}
            <Box sx={{ backgroundColor: "#111", borderRadius: "12px", p: 2, mb: 2, border: "1px solid #1e1e1e" }}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
                <Typography sx={sectionLabelSx}>Payment Methods</Typography>
                {paymentMethods.length > 0 && (
                  <IconButton onClick={handleClearPaymentMethod} size="small" sx={{ color: "#666", "&:hover": { color: "#FFC001" } }}>
                    <ClearIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                )}
              </Box>
              <FormControl sx={{ width: "100%" }}>
                <Select multiple size="small" fullWidth value={paymentMethods} onChange={handlePaymentMethodChange}
                  renderValue={(selected) => selected.length > 0 ? <Typography sx={{ color: "#fff !important" }}>{selected.join(", ")}</Typography> : <Typography sx={{ color: "#666 !important" }}>Select payment methods</Typography>}
                  MenuProps={MenuProps} sx={darkSelectSx} displayEmpty
                >
                  {DUMMY_PAYMENT_METHODS.map((method) => (
                    <MenuItem key={method} value={method} sx={{ color: "#fff", "&:hover": { backgroundColor: "#222" } }}>
                      <Checkbox checked={paymentMethods.indexOf(method) > -1} sx={{ color: "#FFC001 !important" }} size="small" />
                      <ListItemText primary={method} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            {/* Age */}
            {page !== "Services" && (
              <Box sx={{ backgroundColor: "#111", borderRadius: "12px", p: 2, mb: 2, border: "1px solid #1e1e1e" }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
                  <Typography sx={sectionLabelSx}>Age</Typography>
                  {(minAge !== "" || maxAge !== "") && (
                    <IconButton onClick={handleClearAge} size="small" sx={{ color: "#666", "&:hover": { color: "#FFC001" } }}>
                      <ClearIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  )}
                </Box>
                <Box sx={{ display: "flex", gap: 1.5 }}>
                  <TextField label="Min" fullWidth size="small" type="number" value={minAge} onChange={handleMinAgeChange} inputProps={{ min: 0 }} sx={darkTextFieldSx}
                    InputProps={{ endAdornment: <InputAdornment position="end" sx={{ color: "#888" }}>YR</InputAdornment> }}
                  />
                  <TextField label="Max" fullWidth size="small" type="number" value={maxAge} onChange={handleMaxAgeChange} inputProps={{ min: 0 }} sx={darkTextFieldSx}
                    InputProps={{ endAdornment: <InputAdornment position="end" sx={{ color: "#888" }}>YR</InputAdornment> }}
                  />
                </Box>
              </Box>
            )}
          </DialogContent>
          <DialogActions
            style={{
              display: "flex",
              borderTop: "1px solid #2a2a2a",
            }}
          >
            <Grid
              container
              display={"flex"}
              flex={1}
              sx={{ justifyContent: "space-between", padding: "15px" }}
            >
              <Grid item sx={{ display: "flex", justifyContent: "flex-start" }}>
                <Button
                  onClick={handleClearAll}
                  sx={{
                    background: "transparent",
                    border: "1px solid #FFC001",
                    maxWidth: "150px",
                    marginX: { md: "10px" },
                    "&:hover": { background: "rgba(255,192,1,0.1)" },
                  }}
                  variant="outlined"
                >
                  <Typography
                    sx={{
                      color: "#FFC001 !important",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    Clear All
                  </Typography>
                </Button>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button onClick={handleClose} sx={{ marginRight: "10px", color: "#888" }}>
                  Cancel
                </Button>

                <Button
                  onClick={handleApplyFilter}
                  sx={{
                    background: "#FFC001",
                    maxWidth: "150px",
                    "&:hover": { background: "#e6ac00" },
                  }}
                  variant="contained"
                >
                  <Typography
                    sx={{
                      color: "#000 !important",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    Apply
                  </Typography>
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: { md: 250, sm: 200 },
      backgroundColor: "#1a1a1a",
      color: "#fff",
      border: "1px solid #2a2a2a",
    },
  },
};
const useStyles = makeStyles({
  capitalizedButton: {
    color: "#d89700",
    fontFamily: "SharpSans",
    fontWeight: "bolder",
    fontSize: "16px",
  },
});

const mapStateToProps = ({ Auth, Categories, Services }, ownProps) => ({
  jwtToken: Auth.jwtToken,
  user: Auth.user,
  Categories:
    ownProps.page !== "Services" ? Categories.classes : Services.services,
  breedsRaw:
    ownProps.page !== "Services" ? Categories.breeds : Services.subServices,
  subBreedsRaw: Categories.subBreeds,
  subBreedGenetics: Categories.subBreedGenetics,
});

const mapDispatchToProps = (dispatch) => ({
  loadBreeds: (categoryId) => {
    dispatch(Actions.thunkLoadBreeds(categoryId));
  },
  loadListings: ({ filtersData, jwtToken }) =>
    dispatch(
      Actions.thunkLoadListing({
        filtersData,
        jwtToken,
      })
    ),
  loadSubBreeds: (breedId) => {
    dispatch(Actions.thunkLoadSubBreeds(breedId));
  },
  loadServices: () => dispatch(Actions.thunkLoadServices()),

  loadSubServices: (serviceId) =>
    dispatch(Actions.thunkLoadSubServices(serviceId)),

  loadServiceListings: ({ filtersData, jwtToken }) =>
    dispatch(
      Actions.thunkLoadServiceListings({
        filtersData,
        jwtToken,
      })
    ),
  loadSubBreedsGenetics: (geneticsId) =>
    dispatch(Actions.thunkLoadSubBreedGenetics(geneticsId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterModal);
